<template>
  <CHeader position="sticky" class="mb-4">
    <CContainer fluid>
      <CHeaderToggler class="ps-1" @click="$store.commit('toggleSidebar')">
        <CIcon icon="cil-menu" size="lg" />
      </CHeaderToggler>
      <CHeaderBrand class="mx-auto d-lg-none" to="/">
        <CIcon :icon="logo" height="48" alt="Logo" />
      </CHeaderBrand>
      <CHeaderNav class="d-none d-md-flex me-auto">
        <CNavItem>
          <CNavLink href="/exam-checker"> Exam Checker </CNavLink>
        </CNavItem>
      </CHeaderNav>
      <div class="float-right">
        <CDropdown>
          <CDropdownToggle class="acc_dropdown"> 
            <CIcon icon="cilUser" />
            {{user}}
          </CDropdownToggle>
          <CDropdownMenu class="dropdown">
            <CDropdownItem @click="goToChangePassword">
              <CIcon icon="cilLockLocked" /> Change Password
            </CDropdownItem>
            <CDropdownItem @click="logout" style="color: red;">
              <CIcon icon="cilAccountLogout" /> Logout
            </CDropdownItem>
          </CDropdownMenu>
        </CDropdown>
      </div>
    </CContainer>
    <CHeaderDivider />
    <CContainer fluid>
      <AppBreadcrumb />
    </CContainer>
  </CHeader>
</template>

<script>
import AppBreadcrumb from './AppBreadcrumb'
import { logo } from './../assets/brand/logo'

export default {
  name: 'AppHeader',
  components: {
    AppBreadcrumb,
  },
  setup() {
    return {
      logo,
    }
  },
  data(){
    return{
      user: localStorage.getItem('ufn') || null,    
    }
  },
  methods: {
    async logout() {
      try {
        const token = localStorage.getItem("token");

        await this.$axios.post(`${this.$baseUrl}/logout`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });

        localStorage.removeItem("token");
        delete this.$axios.defaults.headers.common["Authorization"];
        this.$router.push("/login");
      } catch (error) {
        console.error("Logout failed", error);
      }
    },
    goToChangePassword(){
      this.$router.push({ name: 'Change Password' });
    }
  }
}
</script>
<style scoped>
.dropdown > .dropdown-item {
  padding: 13px;
}

.acc_dropdown{
  box-shadow: none !important;
}
</style>
